import { createSelector } from 'reselect';
import { businessRulesSelector } from '../selectors';

export const shapeFieldsSelector = createSelector(
  businessRulesSelector,
  (state) => state.get('shapeFields').toJS()
);

export const overhangFieldsSelector = createSelector(
  businessRulesSelector,
  (state) => state.get('overhangFields').toJS()
);

export const kitchenIslandOverhangFieldsSelector = createSelector(
  businessRulesSelector,
  (state) => state.get('kitchenIslandOverhangFields').toJS()
);

export const shapesFlippedSelector = createSelector(
  businessRulesSelector,
  (state) => state.get('shapesFlipped')
);

export const kitchenIslandFlippedSelector = createSelector(
  businessRulesSelector,
  (state) => state.get('kitchenIslandFlipped')
);
